import Table from '@space-lib/components/table'
import defaultMember from '@space-shell/assets/images/default-banned-member.svg'
import Avatar from '@space-shell/common/components/avatar'

import { ModerationTableActions } from '@space-shell/modules/communities/membersAndPermissions/components'

import type { MemberListRowProps } from './types'

const MemberListRow = ({
  communityId,
  member,
  shouldRenderExpirationDate,
  isRemoveActionEnabled,
  refetchGetFollowersRoles
}: MemberListRowProps) => {
  return (
    <Table.Row dataTest='member-list-card'>
      <Table.Data>
        <div className='_d-flex _justify-content-start _align-items-center'>
          <div className='_mr-4'>
            <Avatar
              className='_bg-gray-300'
              size='md'
              urlAvatar={member.imagePath || defaultMember}
            />
          </div>

          <div className='_d-flex _flex-column'>
            <h2 className='_text-2 _text-gray-900 _mb-0'>{member.name || member.userName}</h2>

            {member.email ? (
              <small className='_text-1 _text-gray-900' data-test='card-member-user-email'>
                {member.email}
              </small>
            ) : null}
          </div>
        </div>
      </Table.Data>

      <ModerationTableActions
        communityId={Number(communityId)}
        member={member}
        shouldRenderExpirationDate={shouldRenderExpirationDate}
        isRemoveActionEnabled={isRemoveActionEnabled}
        refetchGetFollowersRoles={refetchGetFollowersRoles}
      />
    </Table.Row>
  )
}

export default MemberListRow
